export const brandDefault = {
  50: '#8c6fae',
  100: '#705391',
  200: '#805b91',
  300: '#7d5191',
  400: '#76478b',
  500: '#73398d',
  600: '#451767',
  700: '#3d125f',
  800: '#310952',
  900: '#280348',
};

export const colors = (brand: any = brandDefault) => ({
  black: '#1a1a1a',
  pureBlack: '#000',
  white: '#fff',
  transparent: {
    100: '0.1',
    200: '0.2',
    500: '0.4',
    600: '0.6',
    800: '0.8',
  },
  primary: {
    50: '#f7f9fc',
    300: '#e1e9ef',
    500: '#c7d3d9', // main
    800: '#777a7c',
    900: '#373d43',
  },
  main: {
    100: '#1a1a1a',
  },
  alert: {
    red: {
      100: '#FDE9EB',
      200: '#FDE9EB',
      300: '#FCD3D8',
      400: '#F24F63',
      500: '#F24F63',
      600: '#EF233C',
      700: '#EF233C',
      800: '#CC0F26',
      900: '#CC0F26',
    },
    orange: {
      100: '#FFF3E5',
      200: '#FFF3E5',
      300: '#FFE7CB',
      400: '#FF9E30',
      500: '#FF9E30',
      600: '#FB8500',
      700: '#FB8500',
      800: '#C96A00',
      900: '#C96A00',
    },
  },
  blue: {
    100: '#EDF4FD',
    200: '#EDF4FD',
    300: '#DAE9FC',
    400: '#6CA9F2',
    500: '#6CA9F2',
    600: '#4793EF',
    700: '#4793EF',
    800: '#1472E4',
    900: '#1472E4',
  },
  brand: {
    orange: brand,
    yellow: {
      100: '#FFFBEC',
      200: '#FFFBEC',
      300: '#FCD3D8',
      400: '#FFE164',
      500: '#FFE164',
      600: '#FFD93D',
      700: '#FFD93D',
      800: '#FDCB00',
      900: '#FDCB00',
    },
    green: {
      100: '#EDFBF4',
      200: '#EDFBF4',
      300: '#DBF8EA',
      400: '#6EE2AA',
      500: '#27C478',
      600: '#4ADB95',
      700: '#4ADB95',
      800: '#27C478',
      900: '#27C478',
    },
    blue: {
      500: '#43415C',
    },
    ...brand,
  },
  gray: {
    50: '#F7FAFC',
    100: '#EDF2F7',
    200: '#E2E8F0',
    300: '#CBD5E0',
    400: '#A0AEC0',
    500: '#718096',
    600: '#4A5568',
    700: '#2D3748',
    800: '#1A202C',
    900: '#171923',
  },
  tableGray: {
    50: '#FFFFFF',
    100: '#EDEDEE',
    200: '#E2E8F0',
    300: '#CBD5E0',
    400: '#A0AEC0',
    500: '#718096',
    600: '#4A5568',
    700: '#D3D3D3',
    800: '#1A202C',
    900: '#171923',
  },
  customGray: {
    200: '#A1A1A1',
    400: '#717171',
    500: '#424242',
    550: '#3D3D3D',
    600: '#313131',
    700: '#2D2D2D',
    750: '#272727',
    900: '#111111',
  },
  neutral: {
    100: '#fff',
    200: '#f7f9fc',
    300: '#e1e9ef',
    400: '#c7d3d9',
    500: '#959595',
    600: '#777a7c',
    700: '#373d43',
    800: '#2B2B2B',
    900: '#1a1a1a',
  },

  text: {
    main: '#4A4F55',
    mainHover: '#1c1e20',
    help: '#777a7c',
    table: '#686868',
  },
});
